import "@wwg/ui/dist/index.css";
import "./index.css";

import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import { Auth, LoginGuard } from "./auth";
import { QueryClient, QueryClientProvider } from "react-query";
import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import Backend from "i18next-http-backend";
import {SettingLanguages } from "hooks/useSettings";
import { CollectContainer } from "CollectExample/useCollect";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 10, // keep data cached for 10 minutes unless invalidated earlier
    },
  },
});

var language = "en";
var settingString = localStorage.getItem("setting-language")
if(settingString){
  const setting = JSON.parse(settingString)
  if(setting.language){
    if(setting.language == SettingLanguages.Spanish){
      language = 'es'
    }
  }
}

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: require("./Locales/en.json"),
      },
      es: {
        translation: require("./Locales/es.json"),
      },
    },
    lng: language,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    pluralSeparator: "_",
  });

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Auth.Provider>
        <LoginGuard>
          <Router>
            <CollectContainer.Provider>
              <App />
            </CollectContainer.Provider>
          </Router>
        </LoginGuard>
      </Auth.Provider>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
